import React from 'react';
import {Redirect} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import SubHeader from '../components/SubHeader';
import {
  Button,
  FormItem,
  Input,
} from '@mayo/mayo-ui-gakki';
import {useAuthContext} from '../context/auth-context';
import FullPageLoader from '../components/FullPageLoader';

interface FormValues {
  email: string;
  password: string;
}

export default function LoginPage() {
  const {login, isFetching, isLogin, companyId, forceLogoutThenLogin} =
    useAuthContext();
  const {control, formState, errors, handleSubmit} = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
  });

  if (isLogin && companyId) {
    return <Redirect to={'/gakki'} />;
  }

  return (
    <React.Fragment>
      {isFetching && <FullPageLoader />}
      <div
        className={
          'flex justify-center items-center min-h-[520px] h-[calc(100vh-174px)]'
        }
      >
        <form
          onSubmit={handleSubmit(data =>
            login({...data}).catch(() => {
              if (
                window.confirm(
                  '該帳號已在其他電腦登入，如強制登入將導致尚未儲存之資料被清除，請問是否仍要強制登入',
                )
              ) {
                forceLogoutThenLogin(data);
              }
            }),
          )}
          className={
            'w-[440px] h-[441px] bg-white rounded border border-[#e3e4e6] px-[13px] flex flex-col justify-between'
          }
        >
          <div>
            <SubHeader className={'!h-[66.3px] !m-0'}>登入系統</SubHeader>
            <div className="grid pt-4 gap-4">
              <FormItem
                label="使用者帳號"
                errorMessage={formState.isSubmitted && errors.email ? errors.email?.message : ''}
              >
                <Controller
                  render={formProps => (
                    <Input
                      {...formProps}
                      isError={Boolean(formState.isSubmitted && errors.email)}
                      placeholder="請輸入您的email"
                    />
                  )}
                  name="email"
                  control={control}
                  rules={{
                    validate: {
                      emailValidate: v => {
                        const emailRegex =
                          /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                        return emailRegex.test(v) || '信箱格式錯誤';
                      },
                    },
                  }}
                />
              </FormItem>
              <FormItem label="密碼">
                <Controller
                  render={formProps => (
                    <Input
                      {...formProps}
                      type="password"
                      isError={Boolean(formState.isSubmitted && errors.password)}
                      placeholder="請輸入您的密碼"
                    />
                  )}
                  name="password"
                  control={control}
                  rules={{required: true}}
                />
              </FormItem>
            </div>
          </div>
          <div
            className={
              'h-[73.2px] border-t border-t-[#e9eced] py-[19px] flex justify-end'
            }
          >
            <Button variant={'solid'} colorSchema={'primary'} type="submit">登入</Button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}
